import React from "react";
import A from "../../AnchorTemplate/Anchor";
import { FaTwitter, FaFacebookF, FaInstagram } from "react-icons/fa";
import footerLogo from "../../../loghi/footer-logo.webp";

import "./BottomFooter.scss";

const BottomFooter = ({ primaryColor, datiFarmacia }) => {
  return (
    <div className="bottom-footer" style={{ backgroundColor: primaryColor }}>
      <div className="container">
        <div className="copy-social">
          <div className="copy-footer">
            <A
              href="https://www.farmakom.it/ecommerce-farmacie/"
              target="_blank"
            >
              © Ecommerce Farmacie
            </A>
            <A href="https://www.farmakom.it/" target="_blank">
              <img src={footerLogo} />
            </A>
          </div>
          <div className="social-footer">
            {(datiFarmacia.socialTwitterLink ||
              datiFarmacia.socialFacebookLink ||
              datiFarmacia.socialInstagramLink) && (
              <ul className="social">
                {datiFarmacia.socialTwitterLink && (
                  <li>
                    <A href={datiFarmacia.socialTwitterLink} target="_blank">
                      <FaTwitter />
                    </A>
                  </li>
                )}
                {datiFarmacia.socialFacebookLink && (
                  <li>
                    <A href={datiFarmacia.socialFacebookLink} target="_blank">
                      <FaFacebookF />
                    </A>
                  </li>
                )}
                {datiFarmacia.socialInstagramLink && (
                  <li>
                    <A href={datiFarmacia.socialInstagramLink} target="_blank">
                      <FaInstagram />
                    </A>
                  </li>
                )}
              </ul>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BottomFooter;
